import UnassignedTaskList from './unassigned_task_list';

export default UnassignedTaskList;
